import axios from 'axios';
import { API_URL } from '../config/api';

/**
 * Service pour les appels API d'authentification
 */

// Inscription
export const register = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/register`, {
      email,
      password
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || 'Erreur lors de l\'inscription'
    };
  }
};

// Connexion
export const login = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, {
      email,
      password
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || 'Erreur lors de la connexion'
    };
  }
};

// Déconnexion
export const logout = async (token) => {
  try {
    const response = await axios.post(
      `${API_URL}/auth/logout`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || 'Erreur lors de la déconnexion'
    };
  }
};

// Vérifier l'email
export const verifyEmail = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/auth/verify-email?token=${token}`);
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || 'Erreur lors de la vérification'
    };
  }
};

// Renvoyer l'email de vérification
export const resendVerification = async (email) => {
  try {
    const response = await axios.post(`${API_URL}/auth/resend-verification`, {
      email
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || 'Erreur lors du renvoi de l\'email'
    };
  }
};

// Obtenir l'utilisateur actuel
export const getCurrentUser = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/auth/me`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || 'Erreur lors de la récupération du profil'
    };
  }
};

// Historique des générations
export const getGenerationHistory = async (token, limit = 50) => {
  try {
    const response = await axios.get(`${API_URL}/generation/history?limit=${limit}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || 'Erreur lors de la récupération de l\'historique'
    };
  }
};

// Statistiques utilisateur
export const getUserStats = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/generation/stats`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || 'Erreur lors de la récupération des statistiques'
    };
  }
};












